import { Auth } from 'aws-amplify';

import { xhrKey } from '@actions/xhr';
import * as constants from '@config/constants';
import { fetchAndParseResponse } from '@utils/fetchUtils';

const apiMiddleware = ({ dispatch, getState }) => next => async action => {
  next(action);

  if (action.type !== constants.API_REQUEST) {
    return;
  }

  const key = xhrKey(action.payload);

  dispatch({
    key,
    type: constants.XHR_IN_PROGRESS,
  });

  let session = null;
  try {
    session = await Auth.currentSession();
  } catch (e) {
    // No active session...
  }

  const { body, url, method } = action.payload;
  const isEngimaApi = url.startsWith(process.env.REACT_APP_API_BASE_URL);
  const enigmaApiKey = getState().keys?.key;

  const options = {
    ...(body && { body: JSON.stringify(body) }),
    method,
    headers: {
      ...(['POST', 'PUT'].includes(method) && {
        'Content-Type': 'application/json',
      }),
      ...(!isEngimaApi &&
        session && { Authorization: session.getIdToken().jwtToken }),
      ...(isEngimaApi && { 'x-api-key': enigmaApiKey }),
    },
    redirect: 'follow',
    referrer: 'no-referrer',
  };

  const { response, error } = await fetchAndParseResponse(url, options);

  dispatch({
    key,
    type: constants.XHR_COMPLETE,
    payload: {
      body: response,
    },
  });

  return { response, error };
};

export default apiMiddleware;
